// Compatibility hook for legacy video action logging call sites.
import { useCallback } from 'react'

interface VideoActionDetails {
  videoId: string
  videoName: string
  videoSize?: number
  frameNumber?: number
  frameFileName?: string
  thumbnailSize?: number
  width?: number
  height?: number
  timestamp?: number
}

// Define all video-related action types
export type VideoActionType = 
  | 'video_uploaded'  // When a video is added to the library
  | 'video_deleted'   // When a video is removed from the library
  | 'video_duplicated' // When a video is copied in the library
  | 'frame_extracted' // When a frame is saved
  | 'video_played'    // When video playback starts
  | 'thumbnail_generated' // When a thumbnail is created
  | 'video_metadata_updated' // When video metadata is updated
  | 'video_upload_failed' // When local save fails
  | 'library_synced' // When the local library is refreshed

export function useVideoWithAudit() {
  const logVideoAction = useCallback((
    _actionType: VideoActionType,
    _message: string,
    _videoDetails: Partial<VideoActionDetails>,
    _options?: {
      toast?: boolean
      severity?: 'info' | 'warning' | 'error'
      additionalDetails?: Record<string, unknown>
    }
  ) => {
    return null
  }, [])
  
  return {
    logVideoAction
  }
}